export const DEFAULT_TASK_DEADLINE = 'до следующего совещания';

const PLACEHOLDER_DEADLINES = new Set([
  '',
  '—',
  '-',
  'не указано',
  'не определён',
  'не определен',
  'не определён.',
  'не определен.',
]);

/** Нормализует срок поручения для отображения в протоколе и задачах. */
export function formatTaskDeadline(deadline?: string | null): string {
  const trimmed = (deadline || '').trim();
  if (!trimmed || PLACEHOLDER_DEADLINES.has(trimmed.toLowerCase())) {
    return DEFAULT_TASK_DEADLINE;
  }
  return trimmed;
}
